import { types, NAME } from "./reducer";
import { RSAA } from "redux-api-middleware";
import entryPoint from "../../constants/endpoints";
import sortingRule_Products from "../../constants/sorting_rules";

import { actions as companyActions } from "../Companies/actions";
import { actions as mainActions } from "../Root/actions";



export const actions = {
  getRevenue: (data) => (dispatch) => dispatch({}),
  setCurrentProduct: (value) => (dispatch, getState) => {
    let thisState = getState()[NAME];
    let selected = thisState.productsList.find((element, index, array) => {
      return element.id === value;
    });
    dispatch(companyActions.editProductAction());
    return dispatch({
      type: types.SELECTED_PRODUCT_SET,
      payload: selected,
    });
  },
  dropCurrentProduct: () => (dispatch, getState) => {
    return dispatch({
      type: types.SELECTED_PRODUCT_DROP,
    });
  },
  getProductList: (data) => ({
    [RSAA]: {
      types: [
        {
          type: types.PRODUCT_LIST_REQUEST,
          payload: (action, state, res) => {
            return;
          },
        },
        {
          type: types.PRODUCT_LIST_SUCCESS,
          payload: (action, state, res) =>
            res.json().then((data) => {
              const sortProducts = (products) => {
                return products.sort((a, b) => {
                  const indexA = sortingRule_Products.indexOf(a.name);
                  const indexB = sortingRule_Products.indexOf(b.name);
                  return indexA - indexB;
                });
              };
              const sortedData = sortProducts(data);
              return sortedData;
            }),
        },
        {
          type: types.PRODUCT_LIST_FAILURE,
          payload: (action, state, res) => {
            return;
          },
        },
      ],
      endpoint: `${entryPoint}/productlist`,
      credentials: "include",
      method: "POST",
      body: JSON.stringify(data),
      headers: { "Content-Type": "application/json" },
    },
  }),
  createProduct: (data) => (dispatch) =>
    dispatch({
      [RSAA]: {
        types: [
          {
            type: types.PRODUCT_CREATE_REQUEST,
            payload: (action, state, res) => {
              return;
            },
          },
          {
            type: types.PRODUCT_CREATE_SUCCESS,
            payload: (action, state, res) =>
              res.json().then(() => {
                let alert = {
                  show: true,
                  alertTitle: "Товар успешно добавлен",
                  severity: "success",
                  style: {},
                  variant: "outlined",
                };
                dispatch(mainActions.showAlert(alert));
                data.backToProductList();
                return;
              }),
          },
          {
            type: types.PRODUCT_CREATE_FAILURE,
            payload: (action, state, res) =>
              res.json().then((data) => {
                let alert = {
                  show: true,
                  alertTitle: "Ошибка при добавлении товара",
                  alertText: "Не извесная ошибка",
                  severity: "error",
                  style: {},
                  variant: "outlined",
                };
                if (data.message.sqlState === "45001") {
                  alert = {
                    ...alert,
                    alertText: "Товар уже сущевствует!",
                  };
                }
                dispatch(mainActions.showAlert(alert));
                return;
              }),
          },
        ],
        endpoint: `${entryPoint}/createproduct`,
        credentials: "include",
        method: "POST",
        body: JSON.stringify(data.data),
        headers: { "Content-Type": "application/json" },
      },
    }),
  editProduct: (data) => (dispatch) =>
    dispatch({
      [RSAA]: {
        types: [
          {
            type: types.PRODUCT_EDIT_REQUEST,
            payload: (action, state, res) => {
              return;
            },
          },
          {
            type: types.PRODUCT_EDIT_SUCCESS,
            payload: (action, state, res) =>
              res.json().then(({ responceData }) => {
                let alert = {
                  show: true,
                  alertTitle: "Ваши изменения внесены",
                  severity: "success",
                  style: {},
                  variant: "outlined",
                };
                dispatch(mainActions.showAlert(alert));
                data.backToProductList();
                return;
              }),
          },
          {
            type: types.PRODUCT_EDIT_FAILURE,
            payload: (action, state, res) => {
              return;
            },
          },
        ],
        endpoint: `${entryPoint}/editproduct`,
        credentials: "include",
        method: "POST",
        body: JSON.stringify(data.data),
        headers: { "Content-Type": "application/json" },
      },
    }),
};
